import {addGlobalEventListener} from "../utils"

const WATCHDOG_ADD_BUTTON_SELECTOR = ".js-watchdog-add"
const PRODUCT_ID_ATTRIBUTE = "data-product-id"

addGlobalEventListener("click", WATCHDOG_ADD_BUTTON_SELECTOR, (button) => {
  const productId = button.getAttribute(PRODUCT_ID_ATTRIBUTE)
  if (!productId) return

  const productIdInput = document.querySelector<HTMLInputElement>(".f-watchdog__product-id-input")

  if (productIdInput) productIdInput.value = productId
})
